import styled from "@emotion/styled"
import { blendWithWhiteBackground } from "../../../util"
import type { StyledProps } from "./dropdown.interfaces"

export const DropdownWrapper = styled.div`
  display: flex;
  position: relative;
`

export const DropdownButton = styled.button<StyledProps>`
  color: ${({ isOpen, roomStyles }) =>
    roomStyles?.servicePanelElementPrimaryText ??
    (isOpen ? "#fff" : "#6c757d")};
  transition: 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  cursor: pointer;
  user-select: none;
  background-color: ${({ isOpen, roomStyles }) =>
    roomStyles?.servicePanelElementBackground ??
    (isOpen ? "#6c757d" : "white")};
  border: ${({ roomStyles, сolorBorder }) =>
    roomStyles?.servicePanelElementBorder
      ? `2px solid ${сolorBorder}`
      : "2px solid #e2e8f0"};
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem 0 0 0.25rem;

  &:after {
    content: "";
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }
`

export const DropdownList = styled.div<StyledProps>`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  min-width: 10rem;
  padding: 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementPrimaryText ?? "#212529"};
  text-align: left;
  list-style: none;
  background-color: ${({ roomStyles }) =>
    blendWithWhiteBackground(roomStyles?.servicePanelElementModalBackground) ?? "#fff"};
  border: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementBorder
      ? `2px solid ${roomStyles?.servicePanelElementBorder}`
      : "2px solid #e2e8f0"};
  border-radius: 0.25rem;
`

export const DropdownItem = styled.div<StyledProps>`
  display: block;
  padding: 0.25rem 1.5rem;
  font-weight: 400;
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementPrimaryText ?? "#16181b"};
  text-align: inherit;
  white-space: nowrap;
  background-color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementBackground ?? "transparent"};
  background-color: transparent;
  border: 0;
  cursor: pointer;
  opacity: 0.75;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &:hover {
    opacity: 1;
  }
`
